export default "__VITE_ASSET__1c33c0f9__"